import {
  Card,
  CardContent,
  Typography,
  Box,
  SxProps,
  Theme,
} from '@mui/material';

interface StatCardProps {
  title: string;
  value: number;
  sx?: SxProps<Theme>;
  onClick?: () => void;
  selected?: boolean;
}

export const StatCard = ({
  title,
  value,
  sx,
  onClick,
  selected,
}: StatCardProps) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        color: '#fff',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: selected
          ? '0 10px 25px rgba(0,0,0,0.1)'
          : '0 10px 25px rgba(0,0,0,0.01)',
        transform: selected ? 'scale(1.02)' : 'none',
        transition: 'transform 0.2s, box-shadow 0.2s',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              transform: 'scale(1.02)',
              boxShadow: '0 12px 28px rgba(0,0,0,0.12)',
            }
          : {},
        ...sx,
      }}
      onClick={onClick}
    >
      <CardContent>
        <Typography variant="h4" fontWeight={700}>
          {value}
        </Typography>

        <Typography variant="body2" sx={{ opacity: 0.85 }}>
          {title}
        </Typography>
      </CardContent>

      <Box
        sx={{
          position: 'absolute',
          right: -30,
          top: -30,
          width: 120,
          height: 120,
          borderRadius: '50%',
          background: 'rgba(255,255,255,0.08)',
        }}
      />
    </Card>
  );
};
